import type { IconData } from '@stacksjs/iconify-core'

export const arrowThickBottom: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M255.682 494.636L16 254.3v-38.276l143.937-.007V16h192v200.007L495.952 216l-.035 38.688ZM54.931 248.022l200.8 201.342L457.328 248l-137.391.008V48h-128v200.015Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowThickBottom
